import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ComponentType } from '../types/enum';

interface InternetOutageData {
  id: number;
  messageTitle: string;
  cardText: string;
  bigIcon: string;
  whixScore: number;
}
@Injectable({
  providedIn: 'root',
})
export class InternetOutageService {
  constructor(private translateService: TranslateService) {}

  outageMessageTitleList = [];

  private prepareComponentData() {
    this.outageMessageTitleList = [
      {
        id: 1,
        messageTitle: 'internet_outage#confirmed_outage_legacy',
        cardText: this.translateService.instant('OUTAGE.INTERNET_OUTAGE_TEXT'),
        bigIcon: 'assets/images/rogers-modem-image-legacy.png',
        whixScore: -1,
      },
      {
        id: 2,
        messageTitle: 'internet_outage#confirmed_outage_ignite',
        cardText: this.translateService.instant('OUTAGE.INTERNET_OUTAGE_TEXT'),
        bigIcon: 'assets/images/rogers-modem-image-ignite.png',
        whixScore: -1,
      },
      {
        id: 3,
        messageTitle: 'internet_outage#potential_outage_legacy_no_ticket',
        cardText: this.translateService.instant('OUTAGE.POTENTIAL_OUTAGE_TEXT'),
        bigIcon: 'assets/images/rogers-modem-image-legacy.png',
        whixScore: -1,
      },
      {
        id: 4,
        messageTitle: 'internet_outage#potential_outage_ignite_no_ticket',
        cardText: this.translateService.instant('OUTAGE.POTENTIAL_OUTAGE_TEXT'),
        bigIcon: 'assets/images/rogers-modem-image-ignite.png',
        whixScore: -1,
      },
      {
        id: 5,
        messageTitle: 'whix#ignite_wifi',
        cardText: this.translateService.instant('OUTAGE.WHIX_TEXT'),
        bigIcon: 'assets/images/rogers-modem-image-ignite.png',
        whixScore: -1,
      },
      {
        id: 6,
        messageTitle: 'whix#legacy_wifi',
        cardText: this.translateService.instant('OUTAGE.WHIX_TEXT'),
        bigIcon: 'assets/images/rogers-modem-image-legacy.png',
        whixScore: -1,
      },
    ];
  }

  createObjectForOutageComponent(
    outageData: InternetOutageData
  ): MessageComponent {
    const componentData = {
      bigIconAltText: outageData.cardText,
      cardText: outageData.cardText,
      bigIcon: outageData.bigIcon,
      whixScore: outageData.whixScore,
    };
    return {
      component: ComponentType.SystemMessageComponent,
      componentData: componentData,
    };
  }

  checkIfOutageMessageTitleExist(messageTitle: string): InternetOutageData {
    if (messageTitle) {
      this.prepareComponentData();
      const outageMessageObject = this.outageMessageTitleList.find(
        (outageStatus) => messageTitle.includes(outageStatus?.messageTitle)
      );
      if (outageMessageObject) {
        outageMessageObject.whixScore = this.getWhixScore(messageTitle);
      }
      return outageMessageObject;
    }
  }

  getWhixScore(messageTitle: string): number {
    const numberPattern = /\d+/g;
    const numberMatches = messageTitle?.match(numberPattern);
    return numberMatches && numberMatches.length
      ? parseInt(numberMatches[0])
      : -1;
  }
}
